module.exports = __webpack_public_path__ + "static/key-golfwithyourfriends-4404b653df55559f95e9cf6ea2bfe244.webp";